import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type AccessoryItemClasses =
  | 'gridContainer'
  | 'container'
  | 'priceText'
  | 'smallBody'
  | 'body'
  | 'accessoryCheckContainer'
  | 'accessoryTitle';

const accessoryItemStyles = makeStyles<ISpcTheme, AccessoryItemClasses>(
  theme => ({
    gridContainer: {
      marginBottom: theme.spacing(2),
    },
    container: {
      borderRadius: 10,
      overflow: 'hidden',
      backgroundColor: theme.palette.background.alternate,
      position: 'relative',
      paddingBottom: theme.spacing(3),

      '&:hover': {
        cursor: 'pointer',
      },
    },
    body: {
      padding: 8,
      minHeight: 92,
      [theme.breakpoints.down('sm')]: {
        padding: 5,
      },
    },
    priceText: {
      paddingRight: 5,
    },
    smallBody: {
      padding: 8,
    },
    accessoryCheckContainer: {
      position: 'absolute',
      bottom: 0,
      right: 0,
    },
    accessoryTitle: {
      lineHeight: 1,
    },
  }),
  { name: 'Customise_AccessoryItem' },
);

export default accessoryItemStyles;
